<template>
    <div
        class=""
        :class="[$mq === 'sm' || $mq === 'md' ? 'text-center mt-4' : 'text-center m-top-7']"
    >
        <img src="../assets/no-result.svg" alt="" />
        <p
            :class="[
                $mq === 'sm' || $mq === 'md'
                    ? 'mt-4 fsz-12 m-bottom-4 primary-color fw-bold'
                    : 'm-top-7 m-bottom-4 fsz-14 primary-color fw-bold',
            ]"
        >
            There is no notification
        </p>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
img {
    @media (max-width: 768px) {
        width: 60vw;
    }
}
.no-result-btn {
    @include nextBtn(145px, 32px);
    font-size: 14px;
    font-weight: bold;
    display: inline-block;
    line-height: 32px;
}
</style>
